import Link from '@mui/material/Link';
import { Typography } from '@mui/material';

const Copyright = () => {
  return (
    <Typography variant="helperText" color="grey.500">
      &copy;&nbsp;
      <Link color="inherit" href="https://itrack.hu/" data-qa-element-id="owner-company-link">
        iData Kft.
      </Link>
      &nbsp;{new Date().getFullYear()}
    </Typography>
  );
};

export default Copyright;
